import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "rotary-switch-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rotary-switch-top" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: "1em",
      viewBox: "0 0 320 512"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_2 = [
  _hoisted_1
]

import Label from "@src/components/Label.vue";
import Frame from "@src/components/Frame.vue";
import { computed, ref } from "vue";
import Line from "@src/components/Line.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RotarySwitch',
  props: {
  top: {
    type: Number,
    required: true,
  },
  left: {
    type: Number,
    required: true,
  },
  text: {
    type: String,
    default: null,
  },
  values: {
    type: Array<{ value: string; name: string }>,
    required: true,
  },
},
  emits: ["change"],
  setup(__props, { emit }) {

const props = __props;




const selectedValue = ref(0);

const modeClass = computed(() => {
  return "position-" + selectedValue.value;
});

function computeLine(angleRadians: number): Array<Array<number>> {
  const x = Math.cos(angleRadians);
  const y = Math.sin(angleRadians);
  const center = 55;
  const len = 55 + 10;
  return [
    [center + x * 55, center + y * 55],
    [center + x * len, center + y * len],
  ];
}

const line1Points = computed(() => computeLine(Math.PI / 4));
const line2Points = computed(() => computeLine((3 * Math.PI) / 4));
const line3Points = computed(() => computeLine((5 * Math.PI) / 4));
const line4Points = computed(() => computeLine((7 * Math.PI) / 4));

function toggleMode(): void {
  selectedValue.value = (selectedValue.value + 1) % 4;
  emit("change", props.values[selectedValue.value].value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, {
    radius: "50%",
    left: props.left,
    top: props.top,
    height: 110,
    width: 110,
    text: props.text
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["rotary-switch four-way", [modeClass.value]]),
        onClick: toggleMode
      }, _hoisted_2, 2 /* CLASS */),
      _createVNode(Line, { points: line1Points.value }, null, 8 /* PROPS */, ["points"]),
      _createVNode(Line, { points: line2Points.value }, null, 8 /* PROPS */, ["points"]),
      _createVNode(Line, { points: line3Points.value }, null, 8 /* PROPS */, ["points"]),
      _createVNode(Line, { points: line4Points.value }, null, 8 /* PROPS */, ["points"]),
      _createVNode(Label, {
        top: "-5px",
        left: "110px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.values[0].value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Label, {
        top: "-5px",
        left: "-25px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.values[3].value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Label, {
        top: "90px",
        left: "-25px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.values[2].value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Label, {
        top: "90px",
        left: "110px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.values[1].value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["left", "top", "text"]))
}
}

})